export const uk = {
    'id-predictor': 'ID прогноза: {id}'
};
